import React from 'react'
import { LegalPage } from '.'

export default function TermsOfServicePage() {
  return <LegalPage contentType="terms-of-use" />
}
